
import { createDraftSafeSelector, createEntityAdapter, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AnimalInfo } from "../..";
import { isEqual } from "lodash";
import { RootState } from "../../../Store";
import { AnimalEvent } from "../AnimalDataCalls/GQLCalls/getAnimalCall";

// WARNING make sure we are talking about the same store there will for a be two stores

export interface AnimalEventInfo extends AnimalEvent {
  animal_id: number;
}

export const eventDataAdapter = createEntityAdapter({
  selectId: (event: AnimalEventInfo) => event.eventNo
});


export const eventSlice = createSlice({
  name: "events",
  initialState: eventDataAdapter.getInitialState({loading: "idle"}),
  reducers: {
    addEvent: (state, {payload}: PayloadAction<AnimalEventInfo[]>) => {
      state.loading = "false";
      eventDataAdapter.addMany(state, payload);
    },
    updateEvents: eventDataAdapter.updateOne,
    updateManyEvents: eventDataAdapter.updateMany,
    upsertEvents: (state, {payload}: PayloadAction<AnimalEventInfo[]>) => {
      const existing = eventDataAdapter.getSelectors().selectAll(state);
      if (existing.length !== payload.length || !isEqual(existing, payload)) {
        eventDataAdapter.upsertMany(state, payload);
      }
    },
    clearEvents: eventDataAdapter.removeAll,
  },
  selectors: {
    selectEventByAnimal: createDraftSafeSelector(
      eventDataAdapter.getSelectors().selectAll,
      (_, animal_id: number) => animal_id,
      (events: AnimalEventInfo[], animal_id: number) => 
        events.filter(event => event.eventNo && event.animal_id === animal_id)
    )
  }
})


export const { addEvent, updateEvents, updateManyEvents, clearEvents, upsertEvents } = eventSlice.actions;
export const { selectById: selectEventById, selectAll: selectAllEvents } = eventDataAdapter.getSelectors((state: RootState) => state.graphQlData.events);
export const selectEventByAnimal = eventSlice.getSelectors((state: RootState) => state.graphQlData.events).selectEventByAnimal;